
export default {
    getNivel(state) {
        return state.nivel
    },
    getNiveis(state) {
        return state.niveis
    }
}